import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    buttonSkeleton: {
        height: 50,
        width: 50,
        marginRight: 16,
    },
    dot: {
        height: 8,
        width: 8,
        marginRight: 8,
        backgroundColor: theme.palette.error.main,
        borderRadius: "50%",
    },
    liveText: {
        fontWeight: "bold",
        color: theme.palette.error.main,
    },
    toolbar: {
        height: 76,
        position: "relative",
        margin: "0px 24px",
    },
    footerLeft: {
        position: "absolute",
        left: 0,
        display: "flex",
        alignItems: "center",
    },
    footerMiddle: {
        position: "absolute",
        left: "50%",
        transform: "translate(-50%)",
        display: "flex",
        alignItems: "center",
    },
    footerRight: {
        position: "absolute",
        right: 0,
        display: "flex",
    },
    goToAlert: {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.info.dark,
        },
    },
    link: {
        textDecoration: "none",
    },
}));
